import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const CircleRadioOutlinedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={21} height={21} viewBox="0 0 21 21" fill="none" {...props}>
      <circle
        cx="50%"
        cy="50%"
        r="10px"
        stroke="#4F4F4F"
        strokeWidth="1px"
        fill="none"
      />
    </SvgIcon>
  );
};
